import { DialogActions } from "@mui/material";
import React from "react";

import theme from "Theme/AppTheme";

interface ActionsProps {
    centered?: boolean;
}

export function Actions({
    centered,
    children,
}: React.PropsWithChildren<ActionsProps>) {
    return (
        <DialogActions
            sx={{
                justifyContent: centered ? "center" : "flex-end",
                gap: theme.spacing(1 / 2),
                padding: 0,
            }}
        >
            {children}
        </DialogActions>
    );
}
